module.exports = __webpack_public_path__ + "static/media/3D.b9d5e12f.svg";